import React, { PureComponent } from 'react';
import Modal from '../../../components/Modal';
import { Form, FormGroup, SubmitButton, FormError } from '../../../components/Forms/Forms';
import { Input, Select } from '../../../components/Forms/fields/index';
import rules from '../../../components/Forms/rules';

import MultiFactor from './MultiFactor';

class MyAccountView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    const {
      user,
      changePasswordModalActive,
      changePasswordFormState,
      toggleModal,
      onFormUpdate,
      submitForm,
    } = this.props;
    return (
      <div className="my-account-page">
        <h1>My account</h1>
        <p>
          <strong>Username:</strong>
          {user.username}
        </p>
        <p>
          <strong>User Type:</strong>
          {user.type}
        </p>
        <div className="actions">
          <button className="button" type="button" onClick={()=>toggleModal(true)}>Change Password</button>
        </div>

        <MultiFactor />

        <Modal active={changePasswordModalActive} onClose={()=>toggleModal(false)}>
          <Form state={changePasswordFormState} onSubmit={submitForm} onChange={onFormUpdate}>
            <FormGroup>
              <label>Current Password</label>
              <Input name="oldPassword" type="password" validate={[rules.required()]}/>
              <FormError/>
            </FormGroup>
            <FormGroup>
              <label>New Password</label>
              <Input name="password" type="password" validate={[rules.required()]}/>
              <FormError/>
            </FormGroup>
            <FormGroup>
              <label>Confirm Password</label>
              <Input name="confirm" type="password" validate={[rules.required(), rules.match('password', 'New Password')]}/>
              <FormError/>
            </FormGroup>
            <button type="submit" className="button">Save</button>
          </Form>
        </Modal>

      </div>
    )
  }
}

export default MyAccountView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/MyAccount.view.js